import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { SharedModule } from 'src/app/shared/shared.module'
import { RoleEffects } from './role.effects'
import * as fromRole from './role.reducer'
import { RoleSerializer } from './role.serializer'
import { RoleService } from './role.service'
import { UserRoleModule } from './user-role/user-role.module'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromRole.FEATURE_NAME, fromRole.roleReducer),
        EffectsModule.forFeature([RoleEffects]),
        UserRoleModule
    ],
    declarations: [],
    exports: [UserRoleModule],
    providers: [
        RoleService,
        {
            provide: RoleSerializer,
            useClass: RoleSerializer
        }
    ]
})
export class RoleModule {}
